import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "../api/axiosRest";
import { SUBSCRIPTION } from "../api/urls";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [authState, setAuthState] = useState({
      isAuthenticated: false,
      isSubscribed: false,
      isLoading: true,
    });
  
    const checkAuthAndSubscription = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setAuthState({ isAuthenticated: false, isSubscribed: false, isLoading: false });
        return;
      }
  
      setAuthState((prevState) => ({ ...prevState, isAuthenticated: true }));
  
      try {
        const response = await axiosInstance.get(SUBSCRIPTION.STATUS);

        const { subscriptions, cards, billing_history } = response.data;

  
        let hasActiveSub = false;
        if (subscriptions !== "none" && Array.isArray(subscriptions)) {
          hasActiveSub = subscriptions.some((sub) => {
            const status = (sub.subscription_status || "").toLowerCase();
            if (["active", "trialing"].includes(status)) {
              const periodEnd = new Date(sub.current_period_end);
              if (!isNaN(periodEnd) && periodEnd > new Date()) {
                return true;
              }
            }
            return false;
          });
        }
  
        setAuthState((prevState) => ({ ...prevState, isSubscribed: hasActiveSub, isLoading: false }));
  
        // Persist data regardless to show billing history etc.
        localStorage.setItem("subscription_data", JSON.stringify(subscriptions));
        localStorage.setItem("cards", JSON.stringify(cards));
        localStorage.setItem("billing_history", JSON.stringify(billing_history));
      } catch (error) {
        console.error("Error checking subscription status:", error);
        setAuthState((prevState) => ({ ...prevState, isSubscribed: false, isLoading: false }));
      }
    };
  
    useEffect(() => {
      checkAuthAndSubscription();
    }, []);
  
    const refreshAuthState = () => {
      checkAuthAndSubscription();
    };
  
    return (
      <AuthContext.Provider value={{ ...authState, refreshAuthState }}>
        {children}
      </AuthContext.Provider>
    );
  };
  
